import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SCUIButton } from "../../../../atomic/atoms";
import { enumSnackbarStatusType } from "../../../../types/enums";
import { ConfirmationDialog } from "../SCUIConfirmationDialog/SCUIConfirmationDialog";
import "../../CampaignManagement.scss";
import { showSnackbar } from "../../../../stores/redux/actions";
import { useDispatch } from "react-redux";

export const ButtonWithConfirmation = ({...props}) => {

    const { buttonText, buttonType, confirmationTitle, confirmationMessage, onConfirm, onCancel } = props;

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [showDialog, setShowDialog] = useState(false);

    const handleButtonClick = () => {
      setShowDialog(true);
    };

    const handleConfirm = () => {
      if (onConfirm) {
        onConfirm();
      }
      setShowDialog(false);

      dispatch(showSnackbar({
        message: t("campaignManagement.save.step.dialog.successMessage"),
        status: enumSnackbarStatusType.success
      }))
    };

    const handleCancel = () => {
      if (onCancel) {
        onCancel();
      }
      setShowDialog(false);
    };

    return (
      <div>
        <SCUIButton
          text={buttonText}
          type={buttonType}
          sizeType="icon"
          size={"s"}
          buttonType="button"
          onClick={handleButtonClick}
        />

        {showDialog && (
          <ConfirmationDialog
            open={showDialog}
            title={confirmationTitle}
            description={confirmationMessage}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
          />
        )}
      </div>
    );
  };